const services = [
  {
    icon: 'ri-home-heart-line',
    title: 'Aide Ménagère',
    description: 'Entretien du domicile, nettoyage des pièces, cuisine, salle de bain, sols et surfaces. Un intérieur propre et ordonné pour un cadre de vie agréable et sécurisé.',
    features: ['Nettoyage complet du logement', 'Entretien de la cuisine', 'Salle de bain et WC', 'Rangement et organisation', 'Lessive et repassage', 'Aération et dépoussiérage'],
    image: 'https://readdy.ai/api/search-image?query=professional%20caregiver%20in%20light%20uniform%20cleaning%20tidy%20home%20for%20elderly%20person%20Geneva%20Switzerland%20warm%20bright%20apartment%20organized%20clean%20living%20space%20gentle%20domestic%20help%20service%20natural%20light%20flowers&width=700&height=460&seq=aide-menagere-v2-01&orientation=landscape',
    tag: 'Ménage',
    tagColor: 'bg-rose-100 text-rose-700',
  },
  {
    icon: 'ri-shopping-basket-line',
    title: 'Courses & Commissions',
    description: 'Accompagnement ou réalisation des courses alimentaires et commissions diverses. Gestion de la liste de courses, achats en supermarché, pharmacie et autres commerces.',
    features: ['Courses alimentaires', 'Pharmacie et parapharmacie', 'Accompagnement en magasin', 'Livraison à domicile', 'Gestion du budget courses', 'Commissions diverses'],
    image: 'https://readdy.ai/api/search-image?query=caregiver%20in%20light%20uniform%20helping%20smiling%20elderly%20woman%20shopping%20at%20supermarket%20Geneva%20Switzerland%20friendly%20assistance%20grocery%20shopping%20warm%20supportive%20atmosphere%20natural%20light%20bright%20store&width=700&height=460&seq=aide-courses-v2-01&orientation=landscape',
    tag: 'Courses',
    tagColor: 'bg-amber-100 text-amber-700',
  },
  {
    icon: 'ri-walk-line',
    title: 'Accompagnement & Présence',
    description: 'Présence bienveillante, accompagnement aux rendez-vous médicaux, promenades et sorties. Lutte contre l\'isolement et maintien du lien social pour un mieux-être au quotidien.',
    features: ['Accompagnement médical', 'Promenades et sorties', 'Présence et compagnie', 'Activités et loisirs', 'Aide aux démarches', 'Transport accompagné'],
    image: 'https://readdy.ai/api/search-image?query=caregiver%20walking%20with%20smiling%20elderly%20senior%20person%20in%20sunny%20park%20Geneva%20Switzerland%20companionship%20support%20outdoor%20activity%20warm%20friendly%20relationship%20natural%20environment%20flowers%20trees&width=700&height=460&seq=aide-accompagnement-v2-01&orientation=landscape',
    tag: 'Présence',
    tagColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Aide aux Repas',
    description: 'Préparation de repas équilibrés adaptés aux besoins et goûts de la personne. Aide à la prise des repas si nécessaire, dans le respect des habitudes alimentaires.',
    features: ['Préparation des repas', 'Menus équilibrés', 'Aide à la prise des repas', 'Respect des régimes', 'Courses alimentaires', 'Vaisselle et rangement'],
    image: 'https://readdy.ai/api/search-image?query=caregiver%20in%20light%20uniform%20preparing%20healthy%20colorful%20meal%20for%20elderly%20person%20in%20bright%20warm%20kitchen%20Geneva%20Switzerland%20domestic%20scene%20cooking%20assistance%20home%20care%20service%20natural%20light%20flowers%20on%20counter&width=700&height=460&seq=aide-repas-v2-01&orientation=landscape',
    tag: 'Repas',
    tagColor: 'bg-stone-100 text-stone-700',
  },
];

export default function AideDomicileServices() {
  return (
    <section id="services-aide" className="py-24 bg-stone-50">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-rose-50 border border-rose-200 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-heart-line text-rose-500 text-sm"></i>
            <span className="text-xs font-bold tracking-widest uppercase text-rose-500">Nos Prestations</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Services d'Aide à Domicile</h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Un accompagnement humain et professionnel pour les personnes âgées ou dépendantes, afin de préserver leur autonomie et leur qualité de vie à domicile.
          </p>
        </div>

        {/* Services alternés */}
        <div className="space-y-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-10 items-center bg-white rounded-2xl overflow-hidden border border-stone-100`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2 h-[280px] md:h-[340px] overflow-hidden shrink-0">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2 p-8 lg:p-10">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-11 h-11 flex items-center justify-center bg-rose-500 rounded-xl">
                    <i className={`${service.icon} text-xl text-white`}></i>
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${service.tagColor}`}>{service.tag}</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-500 leading-relaxed mb-6 text-sm">{service.description}</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-7">
                  {service.features.map((feat, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <i className="ri-check-line text-rose-500 mt-0.5 shrink-0 text-sm"></i>
                      <span className="text-sm text-gray-600">{feat}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact-aide"
                  className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-6 py-3 text-sm font-semibold text-white hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Demander ce service
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
